import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import AppHeader from '@/elements/AppHeader.vue'
    import AppFooter from '@/elements/AppFooter.vue'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

    
return (_ctx: any,_cache: any) => {
  const _component_RouterView = _resolveComponent("RouterView")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppHeader),
    _createVNode(_component_RouterView),
    _createVNode(AppFooter)
  ], 64))
}
}

})